var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColored1Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2392_24409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27326 14C7.1376 14 7.0155 13.9533 6.90698 13.86C6.81202 13.7667 6.76454 13.6467 6.76454 13.5V3.56L3.8343 5.78C3.71221 5.87333 3.58333 5.90667 3.44767 5.88C3.32558 5.85333 3.21705 5.78 3.12209 5.66L2.10465 4.36C2.02326 4.24 1.98934 4.11333 2.00291 3.98C2.03004 3.84667 2.10465 3.74 2.22674 3.66L6.86628 0.140001C6.94767 0.0866672 7.02229 0.0533337 7.09012 0.0400006C7.17151 0.0133334 7.25969 0 7.35465 0H9.51163C9.64729 0 9.7626 0.046667 9.85756 0.140001C9.95252 0.233334 10 0.353333 10 0.500001V13.5C10 13.6467 9.95252 13.7667 9.85756 13.86C9.7626 13.9533 9.64729 14 9.51163 14H7.27326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27326 14C7.1376 14 7.0155 13.9533 6.90698 13.86C6.81202 13.7667 6.76454 13.6467 6.76454 13.5V3.56L3.8343 5.78C3.71221 5.87333 3.58333 5.90667 3.44767 5.88C3.32558 5.85333 3.21705 5.78 3.12209 5.66L2.10465 4.36C2.02326 4.24 1.98934 4.11333 2.00291 3.98C2.03004 3.84667 2.10465 3.74 2.22674 3.66L6.86628 0.140001C6.94767 0.0866672 7.02229 0.0533337 7.09012 0.0400006C7.17151 0.0133334 7.25969 0 7.35465 0H9.51163C9.64729 0 9.7626 0.046667 9.85756 0.140001C9.95252 0.233334 10 0.353333 10 0.500001V13.5C10 13.6467 9.95252 13.7667 9.85756 13.86C9.7626 13.9533 9.64729 14 9.51163 14H7.27326Z",
    fill: "url(#paint0_linear_2392_24409)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2392_24409",
    x1: 10,
    y1: 3.5,
    x2: 2,
    y2: 3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E8FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#79C389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#F2BC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5543"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2392_24409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColored1Icon);
export default __webpack_public_path__ + "static/media/colored-1-icon.7f67f1d4f15ebf927ef26229b63650f6.svg";
export { ForwardRef as ReactComponent };